import { PAGINATION_LIMIT_PER_PAGE } from '@dealstack/frontend/shared/other/react/hooks/usePagination';

export const KYC_PAGINATION_PARAMS = {
	OFFSET_PARAM_KEY: 'offset',
	LIMIT_PARAM_KEY: 'limit',
	SEARCH_QUERY_PARAM_KEY: 'search',
	DEFAULT_OFFSET: 0,
	DEFAULT_LIMIT: PAGINATION_LIMIT_PER_PAGE.x25,
	INITIAL_TOTAL_NUMBER_OF_ITEMS: 10,
} as const;
